import { createSlice } from "@reduxjs/toolkit";
import { SmsTemplateResponseDto } from "../../shared/dtos/sms/SmsTemplateResponseDto";
import {
  getInitialCrudState,
  generateCrudReducers,
} from "../utils/crudFactory";

export const smsTemplateSlice = createSlice({
  name: "smsTemplate",
  initialState: getInitialCrudState<SmsTemplateResponseDto>(),
  reducers: {
    ...generateCrudReducers<SmsTemplateResponseDto>(),
  },
});

export const smsTemplateActions = smsTemplateSlice.actions;
export default smsTemplateSlice.reducer;
